import React from 'react';
import selectSendStatus from "./SelectSendStatus";

const SendTypeSellFactor = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {


  const changeHandler = (e) => {
    const value = e.target.value;
    if (value==="inPlace")
      setSendData({sendType: e.target.value , sendStatus:"delivered"})
    else {
      setSendData({sendType: e.target.value , sendStatus:""})
    }

  }
  return (
    <div className={'divgroup'}>
      <label htmlFor="setSendData_factorType">نوع ارسال</label>
      <select
        id={'setSendData_factorType'}
        className="form-select"
        value={sendData.sendType}
        onChange={changeHandler}
        required
      >
        <option value="inPlace">حضوری</option>
        <option value="courier">پیک</option>
        <option value="distributorContractor">پیمانکار توزیع</option>
      </select>
    </div>
  );
};

export default SendTypeSellFactor;
